/**
 * Download file from binary content.
 *
 * @param {string} name  required: file name without extension https://learn.microsoft.com/en-us/windows/win32/fileio/naming-a-file
 * @param {string} type  required: mimetype https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
 * @param {array, string } data required: binary content
 *
 * @return {file} downloadable file.
 */
export default function(name, type, data) {
	const blob = new Blob([data], { type: type });
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement('a');

	document.body.appendChild(a);
	a.style = 'display: none';
	a.href = url;
	a.download = name;
	a.click();
	window.URL.revokeObjectURL(url);
}
